import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=5ca08a10&"
import script from "./Features.vue?vue&type=script&lang=js&"
export * from "./Features.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports